import { pipe, ReadonlyArray } from "fp";
import { heapEvent } from "@equipmentshare/heaper";
import React from "react";

import { Dashboard } from "~/Dashboard";
import * as Data from "~/Data";
import * as Driver from "~/Driver";
import * as Icon from "~/Icon";
import * as Layout from "~/Layout";
import * as Link from "~/Link";
import * as Loading from "~/Loading";
import { Statistic } from "~/Statistic";

// TODO: Move this to `~/Driver.Summary`
export function DriverSummary() {
  return (
    <Dashboard.Section>
      <DriverSummary.Header />
      <DriverSummary.Content />
    </Dashboard.Section>
  );
}

export namespace DriverSummary {
  export const Header = () => {
    const route = Driver.Overview.Route.use();
    const title = pipe(
      Driver.useStore(),
      Data.Store.when({
        loading: () => <Loading.Component>Fleet Overview</Loading.Component>,
        error: () => <>Fleet Overview</>,
        success: () => <>Fleet Overview</>,
      })
    );

    const count = Driver.Count.use();

    return (
      <Layout.Section.Header.Component
        Right={() => <Link.ViewDetails.Component onClick={() => {
          heapEvent("E-Logs - Fleet - Click - View Details Fleet Overview", {
            value: `D: ${count.drive} ON: ${count.on} OFF: ${count.off} PU: ${count.personalUse}  YM: ${count.yardMove}`,
          });
          route.go();
        }} />}
      >
        <Layout.Section.Header.Title>{title}</Layout.Section.Header.Title>
      </Layout.Section.Header.Component>
    );
  };

  export const Content = ({ filtered }: { readonly filtered?: boolean }) => {
    const count = Driver.Count.use(filtered);
    return (
      <Dashboard.Row>
        <DriverSummary.Total {...count} />
        <DriverSummary.EachStatus {...count} />
      </Dashboard.Row>
    );
  };

  export const Total: Component<Driver.Count.Count> = (count) => (
    <Layout.Column.Component flex="auto">
      <Layout.Block.Component all>
        <Statistic
          Title={() => (
            <>
              <Icon.UserHardHat />
              <Layout.Inline.Component left>Drivers</Layout.Inline.Component>
            </>
          )}
          Value={() => <>{Driver.Count.total(count)}</>}
        />
      </Layout.Block.Component>
    </Layout.Column.Component>
  );

  export const EachStatus: Component<Driver.Count.Count> = (count) =>
    pipe(
      [
        [count.drive, Driver.Status.drive()],
        [count.yardMove, Driver.Status.yardMove()],
        [count.personalUse, Driver.Status.personalUse()],
        [count.on, Driver.Status.on()],
        [count.off, Driver.Status.off()],
        [count.sleeperBerth, Driver.Status.sleeperBerth()],
      ],
      ReadonlyArray.map(
        ([count, status]: readonly [number, Driver.Status.Status]) => (
          <Column count={count} status={status} key={status} />
        )
      ),
      (statuses) => <>{statuses}</>
    );

  const Column = ({
    count,
    status,
  }: {
    readonly count: number;
    readonly status: Driver.Status.Status;
  }) => (
    <Layout.Column.Component flex="auto" key={status}>
      <Layout.Block.Component all>
        <Statistic
          Value={() => (
            <span data-testid={`${status}-status-count`}>{count}</span>
          )}
          Title={() => (
            <Driver.Status.Component strong={false} status={status} />
          )}
        />
      </Layout.Block.Component>
    </Layout.Column.Component>
  );
}
